<template>
    <span>
        <VueApexCharts type="line" height="400" :options="chartOptions" :series="series"></VueApexCharts>
    </span>
</template>
  
<script>
// Bar chart for "Active Users" card.
import VueApexCharts from 'vue-apexcharts'

export default {
    components: {
        VueApexCharts,
    },
    props: {
        barChartData: {
            type: Object, default: {
                labels: [],
                datasets: [],
            }
        },
        title: { type: String, default: "Title" },
        isLoaded: { type: Boolean, default: false }
    },
    data() {
        return {
            series: [
            {
              name: "Number of graduates",
              data: this.barChartData['datasets']
            },
          ],
          chartOptions: {
            chart: {
              height: 350,
              type: 'line',
              dropShadow: {
                enabled: false,
                color: '#000',
                top: 18,
                left: 7,
                blur: 10,
                opacity: 0.2
              },
              toolbar: {
                show: false
              }
            },
            colors: ['#1BC6F5', '#545454'],
                    // colors: ['#1BC6F5'],
            dataLabels: {
              enabled: true,
            },
            stroke: {
              curve: 'smooth'
            },
            grid: {
              borderColor: '#e7e7e7',
              row: {
                colors: ['#f3f3f3', 'transparent'], // takes an array which will be repeated on columns
                opacity: 0.5
              },
            },
            markers: {
              size: 1
            },
            xaxis: {
              categories: this.barChartData['labels'],
              title: {
                text: 'Year'
              }
            },
            yaxis: {
              title: {
                text: 'Number of graduates'
              },
              min: 0,
              max: Math.ceil(Math.max(...this.barChartData['datasets'])/1000)*1000
            },
            legend: {
              position: 'top',
              horizontalAlign: 'right',
              floating: true,
              offsetY: -25,
              offsetX: -5
            }
          },
        };
    },
    methods: {
    },
};
</script>